import { FolderFileKey } from "./key";
import { SimpleQueryOptions, useBaseQuery } from "../baseQuery";
import { GetFolderFileDocsPdfPageRequest, GetFolderFileDocsPdfPageResponse } from "@maven-rest/docs/FolderFile.dto";
import { FolderFileUrl } from "@maven-rest/docs/FolderFile.url";

export function useFolderFileDocsPdfPageQuery(
  req: GetFolderFileDocsPdfPageRequest,
  options?: SimpleQueryOptions<GetFolderFileDocsPdfPageResponse, GetFolderFileDocsPdfPageRequest>
) {
  return useBaseQuery({
    queryKey: [FolderFileKey.FolderFileDocsPdfPage, String(req.fileId), String(req.docsPdfId), req.page],
    fnOption: { url: FolderFileUrl.getFolderFileDocsPdfPage(req.fileId, req.page), request: req },
    ...options,
  });
}
